import React from 'react';
import PlanAllocationCategory from '../../containers/PlanAllocationCategory/PlanAllocationCategory';
import AllocationGraphs from '../../containers/AllocationGraphs/AllocationGraphs';
import classes from './PlanAllocation.css';
import {getIndexProtectorLabel} from "../../shared/common";
import {reduce} from 'ramda';

const INTL_EQUITY_INDEX = 1;

const planAllocation = (props) => {

    // work around for color Index
    let filteredAllocations = props.allocation.assets;
    let totalDiv = null;

    filteredAllocations = props.allocation.assets.map((category, index) => {
        if (!props.hasIP7 && index == 4) {
            category.colorIndex = 5;
        } else {
            category.colorIndex = index;
        }

        return category;
    });

    // remap final color for non IP7
    let colors = props.colors.map((color, index) => {
        if (!props.hasIP7 && index == 4) {
            return props.colors[5];
        }
        return color;
    });

    if (props.filterZero) {
        filteredAllocations = filteredAllocations.filter((category) => {
            return category.value > 0.0;
        });
    }

    if (props.editMode) {
        let allocationsTotal = reduce((accum, asset) => {

            let newVal = parseFloat(asset.value);

            if (!isNaN(newVal)) {
                return accum + newVal;
            } else {
                return accum;
            }

        }, 0, filteredAllocations);

        totalDiv = (
          <div className={classes.totalDiv}>
              <label>Total:</label>
              <span>{allocationsTotal.toFixed(1)}%</span>
          </div>
        );

    }

    let allocations = filteredAllocations.map((category, index) => {

        // need to increase contrast on the internation equity index without
        // messing with the actual graph
        let fontColor = "#fff";
        if (index === INTL_EQUITY_INDEX) {
            fontColor = "#777";
        }

        return (
            <PlanAllocationCategory
                updateAllocation={props.updateAllocation}
                editMode={props.editMode}
                key={category.assetId}
                filterZero={props.filterZero}
                category={category}
                color={props.colors[category.colorIndex]}
                fontColor={fontColor}
                displayMode={props.displayMode}
                indexProtector={props.indexProtector}
            />
        );
    });


    let assets = props.allocation.assets;

    if (props.graph !== null) {
        assets = props.graph.assets;
    }

    let title = props.allocation.allocationModelName;
    if (props.indexProtector !== "") {
        title = getIndexProtectorLabel(props.indexProtector.toString(), false);
    }

    return (
        <div className="PlanAllocation">
            <div className="allocation-title">{title}</div>
            <div className="allocationGraph">
                <AllocationGraphs
                    editMode={props.editMode}
                    assets={assets}
                    width={250}
                    colors={colors}
                    highlightIndex={props.highlightIndex} />
            </div>
            {allocations}
            {totalDiv}
        </div>
    );
};

export default planAllocation;


// WEBPACK FOOTER //
// ./src/components/PlanAllocation/PlanAllocation.js